import { EmailProfileContext } from '../Email.contexts'

function EmailProfileProvider({ children, ...restProps }) {
  return <EmailProfileContext value={restProps}>{children}</EmailProfileContext>
}

export default EmailProfileProvider
